export const getFormattedData = originalData => {
	const formattedData = originalData?.map ( el => {
		let image = el?.media?.filter ( val => val?.mediaType === "IMAGE" );

		if ( el?.__typename === "feed" ) {
			return {
				streamTitle   : el?.summary,
				videoId       : el?.id,
				views         : el?.views,
				thumbnail     : image?.[0]?.href ?? "",
				profileId     : el?.actorDetails?.id,
				isCeleb       : el?.actorDetails?.isCeleb,
				isFollowing   : el?.actorDetails?.isFollowing,
				profilePic    : el?.actorDetails?.photo,
				streamerName  : el?.actorDetails?.name,
				profileHref   : `/profile/${ el?.actorDetails?.id }`,
				createdAt     : el.createdAt,
				videoDuration : el?.read_time,
				feedType      : "videos",
				game          : el?.game || null,
				src           : el?.media.find ( item => item.mediaSequence === "3" )?.href ?? "",
				reactions     : el?.reactions?.find ( el => el.reaction === "AGREE" )?.count || 0,
				sharesCount   : el?.sharesCount || 0,
				commentsCount : el?.commentCount || 0
			};
		} else {
			return {
				streamTitle   : el?.sessionInfo,
				isLive        : !el?.endTimeUTC,
				createdAt     : el?.startTimeUTC,
				endTimeUTC    : el?.endTimeUTC,
				cdnUrl        : el?.cdnUrl,
				streamingURL  : el?.streamingURL,
				liveViews     : el?.liveViews,
				thumbnail     : el?.thumbnail,
				videoId       : el?.id,
				views         : el?.liveViews,
				profileId     : el?.broadcaster?.sportsFan?.id,
				isCeleb       : el?.broadcaster?.sportsFan?.isCeleb,
				isFollowing   : el?.broadcaster?.sportsFan?.isFollowing,
				profilePic    : el?.broadcaster?.sportsFan?.photo,
				streamerName  : el?.broadcaster?.sportsFan?.name,
				profileHref   : `/profile/${ el?.broadcaster?.sportsFan?.id }`,
				feedType      : "broadcast",
				game          : el?.game || null,
				reactions     : el?.totalReactions || 0,
				sharesCount   : el?.totalShares || 0,
				commentsCount : el?.totalComments || 0
			};
		}

	} );

	return formattedData;
};
